import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Tag, Typography, Skeleton } from 'antd';
import { ProfileOutlined } from '@ant-design/icons';
import { useDisplaySections } from '@/api/displaySections';
import { useTopics } from '@/hooks/useTopics';
import { PageHero } from '@/components/PageHero';
import { sectionCount, CONTENT_TYPE_NAME } from './contentModel';

export function ContentCenterPage() {
  const nav = useNavigate();
  const secQ = useDisplaySections();
  const topicsQ = useTopics({ status: 'active' });
  const topics = topicsQ.data ?? [];

  return (
    <div style={{ maxWidth: 1000 }}>
      <PageHero
        icon={<ProfileOutlined />}
        title="Content Center"
        subtitle="Maintain topics by section and type"
      />
      {secQ.isLoading ? (
        <Skeleton active />
      ) : (
        <Row gutter={[16, 16]}>
          {(secQ.data ?? []).map((s) => (
            <Col xs={24} sm={12} md={8} key={s.id}>
              <Card hoverable onClick={() => nav(`/content/${s.id}`)} title={s.tag_name}>
                <Typography.Title level={2} style={{ margin: 0 }}>
                  {sectionCount(topics, s.id)}
                </Typography.Title>
                <Typography.Text type="secondary">active topics</Typography.Text>
                <div style={{ marginTop: 12 }}>
                  {s.allowed_type_ids.map((id) => (
                    <Tag key={id}>{CONTENT_TYPE_NAME[id] ?? id}</Tag>
                  ))}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
}
